import { render, staticRenderFns } from "./dstr-support-invoice-upload.vue?vue&type=template&id=1943ffb5"
import script from "./dstr-support-invoice-upload.vue?vue&type=script&lang=js"
export * from "./dstr-support-invoice-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports